/* eslint-disable import/prefer-default-export */

export const SUCCESS = '#240D4D';
